import { spacing5 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const PageHeaderStyleToggleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spacing5};
`;
